
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.31 32.5L27.75 37.06C27.5 37.18 27.2 37 27.2 36.71V27.3C27.2 27.01 27.5 26.83 27.76 26.96L37.32 31.81C37.6 31.95 37.6 32.36 37.32 32.5H37.31ZM64 13.83V50.18C64.02 57.82 56.48 64 47.19 64H17.66C7.9 64 0 57.5 0 49.48V13.84C0 6.2 7.54 0 16.83 0H47.19C56.48 0 64 6.18 64 13.82V13.83ZM49.48 26.9C49.48 22.89 46.23 19.64 42.22 19.64H21.78C17.77 19.64 14.52 22.89 14.52 26.9V37.12C14.52 41.13 17.77 44.38 21.78 44.38H42.22C46.23 44.38 49.48 41.13 49.48 37.12V26.9Z","fill":"#D20311"}})])
          )
        }
      }
    